export default __webpack_public_path__ + "static/media/DocumentMask.3a3c8922.png";